module.exports = __webpack_public_path__ + "static/media/book.64c78d73.svg";